import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { addReturnToAddressOverridesWorkflow } from './addReturnToAddressOverrides';
import { editReturnToAddressOverridesWorkflow } from './editReturnToAddressOverrides';

export const workflows: WorkflowOptions[] = [
  addReturnToAddressOverridesWorkflow,
  editReturnToAddressOverridesWorkflow,
  ...Object.values(generateAssetStatusWorkflow('returnAddressOverride')),
];

export default workflows;
